import { Pipe, PipeTransform } from '@angular/core';
import { find } from './utils/find.utils';

@Pipe({
  name: 'find',
  pure: true // Performance optimization for pure pipes
})
export class FindPipe implements PipeTransform {
  transform(array: any[], key: string, value: any): any {
    return find(array, key, value);
  }
}